import { ButtonV4 } from "../common/ui";

// Types
type StarButtonProps = {
  name: string;
  isOn: boolean;
  onClick: () => void;
};

/** ไอคอนยาเม็ด / แคปซูล ของแถวยา */
export const DrugIcon = (props: { isCapsule: boolean }) => (
  <span className="hv4-ord-line-icon" aria-hidden="true">
    <svg width="26" height="26" viewBox="0 0 26 26">
      {props.isCapsule ? (
        <g transform="rotate(-45 13 13)" stroke="currentColor" strokeWidth="2">
          <rect className="hv4-ord-pill-body" x="2" y="7" width="22" height="12" rx="6" />
          <path className="hv4-ord-pill-half" d="M13 7h5a6 6 0 0 1 0 12h-5z" />
        </g>
      ) : (
        <g stroke="currentColor" strokeWidth="2">
          <circle className="hv4-ord-pill-body" cx="13" cy="13" r="10" />
          <path d="M5 13h16" />
        </g>
      )}
    </svg>
  </span>
);

/** ดาวเพิ่ม / เอาออกจากรายการโปรด */
export const StarButton = (props: StarButtonProps) => {
  const label = `${props.isOn ? "เอาออกจากรายการโปรด" : "เพิ่มเป็นรายการโปรด"} ${props.name}`;

  return (
    <ButtonV4
      variant="plain"
      size="icon"
      aria-pressed={props.isOn}
      aria-label={label}
      title={label}
      className={`hv4-ord-star${props.isOn ? " hv4-ord-star-on" : ""}`}
      onClick={props.onClick}
    >
      {props.isOn ? "★" : "☆"}
    </ButtonV4>
  );
};

DrugIcon.displayName = "DrugIcon";

StarButton.displayName = "StarButton";
